import { Deserializable } from "../../../common/deserializable";
import { UserInformaions } from "../../../common/userinformations";

/* class utilisé pour stocker les id des valeurs saisie à l'écran de recherche. elles seront envoyés pour le webService
pour récupèrer les offres commerciales liées*/
export class RechercheOffresCommercialesForm implements Deserializable {
  codeLangue: string;
  idPortImport: number;
  idPortExport: number;
  idTypeTransport: number;
  idCompagnie: number;
  directTransbo: string;
  portArrivee: string;
  idManutentionnaire: number;
  userInformations: UserInformaions;
  advanceSearch: boolean;
  portImport: string;
  portExport: string;
  typeTransport: string;
  compagnie: string;
  manutentionnaire: string;
  constructor(
    codeLangue,
    idPortImport,
    idPortExport,
    idTypeTransport,
    idCompagnie,
    directTransbo,
    portArrivee,
    idManutentionnaire,
    userInformations,
    advanceSearch,
    portImport,
    portExport,
    typeTransport,
    compagnie,
    manutentionnaire
  ) {
    this.codeLangue = codeLangue;
    this.idPortImport = idPortImport;
    this.idPortExport = idPortExport;
    this.idTypeTransport = idTypeTransport;
    this.idCompagnie = idCompagnie;
    this.directTransbo = directTransbo;
    this.portArrivee = portArrivee;
    this.idManutentionnaire = idManutentionnaire;
    this.userInformations = userInformations;
    this.advanceSearch = advanceSearch;
    this.portImport = portImport;
    this.portExport = portExport ;
    this.typeTransport = typeTransport;
    this.compagnie = compagnie;
    this.manutentionnaire = manutentionnaire ;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/offrecommerciale/model/form/rechercheOffresCommercialesForm.ts